import React, { useEffect, useState } from "react";

import { ErrorDialog } from "../../primitives/DialogContent";
import { Text } from "@100mslive/react-ui";

export const InitErrorModal = ({ notification }) => {
  const [showModal, setShowModal] = useState(false);
  const [info, setInfo] = useState({ title: "Lỗi khởi tạo", description: "" });

  useEffect(() => {
    const data = notification?.data;
    if (!data || data.action !== "INIT") {
      return;
    }
    let description;
    let title;
    if (data.description.includes("role is invalid")) {
      description =
        "Vai trò này không tồn tại cho phòng nhất định. Hãy thử lại với một vai trò hợp lệ.";
      title = "Vai trò không hợp lệ";
    } else if (data.description.includes("room is not active")) {
      title = "Phòng bị vô hiệu hóa";
      description = "Phòng này bị vô hiệu hóa và không thể tham gia.";
    } else {
      description = data.description;
      title = "Lỗi khởi tạo";
    }
    setInfo({ title, description });
    setShowModal(true);
  }, [notification]);

  return (
    <ErrorDialog
      open={showModal}
      onOpenChange={setShowModal}
      title={info.title}
    >
      <Text variant="sm" css={{ wordBreak: "break-word" }}>
        {info.description} <br />
        URL hiện tại - {window.location.href}
      </Text>
    </ErrorDialog>
  );
};
